import React from 'react';
import { string, func } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import './style.scss';

const HubIndustryTile = ({ title, link, imgUrl, i18nPrefix, onClick }) => (
    <div className="hub-industry-tile-wrapper box-shadow-2">
        <a key={title} onClick={onClick} href={link} className="hub-industry-tile">
            <img src={imgUrl} className="hub-industry-img" alt={translate(`${i18nPrefix}.${title}.alt`)} />
            <p>
                <I18n k={`${i18nPrefix}.${title}.name`} />
            </p>
        </a>
    </div>
);

HubIndustryTile.propTypes = {
    title: string,
    link: string,
    imgUrl: string,
    i18nPrefix: string,
    onClick: func,
};

export default HubIndustryTile;
